import { render, staticRenderFns } from "./VideosProgressBar.vue?vue&type=template&id=676ba928&scoped=true&"
import script from "./VideosProgressBar.vue?vue&type=script&lang=js&"
export * from "./VideosProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./VideosProgressBar.vue?vue&type=style&index=0&id=676ba928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676ba928",
  null
  
)

/* custom blocks */
import block0 from "./VideosProgressBar.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports